import { useEffect } from 'react';

import { Box } from 'components/Box';
import { NotFoundContent } from 'components/NotFoundContent';
import { Layout } from 'layouts/Layout';
import { gutterWidth, maxWidth } from 'theme';
import { setDocumentTitle } from 'utils/meta/setDocumentTitle';

type Props = {
  searchText?: string;
  searchUrl?: string;
};

export function NotFoundPage({ searchText, searchUrl }: Props) {
  useEffect(() => {
    /* TRANSLATORS: 404 page title */
    setDocumentTitle(getText('Page Not Found'));
  }, []);
  return (
    <Layout>
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        px={[gutterWidth / 2, null, null, gutterWidth]}
        py={[gutterWidth / 2, null, null, gutterWidth, '28px']}
      >
        <NotFoundContent searchText={searchText} searchUrl={searchUrl} />
      </Box>
    </Layout>
  );
}
